import clsx from "clsx";
import type { JSX } from "react/jsx-runtime";
import type { AdGallerySlide } from "../../../../../actions/ad/adGallery";
import { getNextPage, getPreviousPage } from "../utils";
import { AdGalleryItem } from "./AdGalleryItem";

type Props = {
  slides: AdGallerySlide[];
  currentPage: number;
  slideDirection: string;
  numPages: number;
  originForTracking: string;
};

export function AdGalleryCarousel({
  slides,
  currentPage,
  slideDirection,
  numPages,
  originForTracking,
}: Props): JSX.Element {
  const previousPage = getPreviousPage(currentPage, numPages);
  const nextPage = getNextPage(currentPage, numPages);
  const slidesToDisplay = [
    slides.find((slide) => slide.currentPage === previousPage),
    slides.find((slide) => slide.currentPage === currentPage),
    slides.find((slide) => slide.currentPage === nextPage),
  ].filter(Boolean) as AdGallerySlide[];

  function getSlideAnimation(slidePage: number): string {
    if (
      slideDirection === "left" &&
      (currentPage === slidePage || nextPage === slidePage)
    ) {
      return "motion-safe:animate-slideRight";
    } else if (
      slideDirection === "right" &&
      (currentPage === slidePage || previousPage === slidePage)
    ) {
      return "motion-safe:animate-slideLeft";
    }
    return "";
  }

  return (
    <div className="-ml-xsmall flex justify-center overflow-hidden">
      {slidesToDisplay.map((slide, index) => (
        <ul
          key={`${slide.entries[0]?.linkUrl}${index}`}
          className={clsx(
            "flex min-w-full flex-wrap justify-between p-xsmall",
            getSlideAnimation(slide.currentPage),
          )}
          aria-hidden={currentPage !== slide.currentPage}
        >
          {slide.entries.map((ad) => (
            <AdGalleryItem
              ad={ad}
              key={`${ad.linkUrl}`}
              isActive={currentPage === slide.currentPage}
              originForTracking={originForTracking}
            />
          ))}
        </ul>
      ))}
    </div>
  );
}
